import { useEffect, useRef } from 'react'
import { useAccount } from 'wagmi'
import { reconnect } from 'wagmi/actions'

import { isMobileSwapWalletWaitActive } from '../domain/swap/mobileSwapSession'
import { isWalletSigningLockActive, shouldBlockWalletReconnect } from '../domain/wallet/walletSigningLock'
import {
  canAttemptWalletReconnect,
  markWalletReconnectCooldown,
} from '../domain/wallet/walletReconnectCooldown'
import { wagmiConfig } from '../wagmi/config'

/**
 * Al volver visible, reintenta reconectar wagmi sin borrar la sesión persistida.
 * No reconecta durante espera de firma de swap (evita abrir MetaMask en bucle).
 */
export default function WalletConnectionKeepAlive() {
  const { status } = useAccount()
  const statusRef = useRef(status)
  statusRef.current = status

  useEffect(() => {
    const tryReconnect = () => {
      if (document.visibilityState !== 'visible') return
      if (
        (isMobileSwapWalletWaitActive() && isWalletSigningLockActive()) ||
        shouldBlockWalletReconnect()
      ) {
        return
      }

      const currentStatus = statusRef.current
      if (currentStatus === 'connected' || currentStatus === 'connecting' || currentStatus === 'reconnecting') {
        return
      }
      if (!canAttemptWalletReconnect()) return

      markWalletReconnectCooldown()
      void reconnect(wagmiConfig).catch(() => {
        /* conector aún despertando tras volver de MetaMask */
      })
    }

    window.addEventListener('pageshow', tryReconnect)
    document.addEventListener('visibilitychange', tryReconnect)
    return () => {
      window.removeEventListener('pageshow', tryReconnect)
      document.removeEventListener('visibilitychange', tryReconnect)
    }
  }, [])

  return null
}
